import FeatureFlags from "@arcteryx/js-feature-flags";

export const FeatureSet = FeatureFlags.define([
  "RedirectJapanToArcteryxJP",
  "enableOutletFlashSaleModal",
  "enableSanityPromoBar",
  "enableOptimizelyClient",
  "useAlgoliaProd",
  "enableSanityStaticSearchLinks",
  "useGraphQLEndpoint",
]);
